const createTableTokens = ({ borderWidths }) => ({
  borderWidths: {
    row: borderWidths[1],
  },
  borderStyles: {
    row: 'solid',
  },
});

export default createTableTokens;
